import { createFileRoute } from "@tanstack/react-router";

import { payerSearchParamsSchema } from "@/domain/payer";
import { PayersScreen } from "@/interactors/PayersScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/payers/")({
  component: PayersScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "payers",
    }),
  head: () => headWithCustomTitle("main:payers.title"),
  validateSearch: payerSearchParamsSchema,
});
